import { useAuthStore } from '@/entities/auth';
import { useKassaLocationMarker } from '@/entities/fiscalization';
import { useConfirm } from '@/shared/lib';

interface LocationSwitchTarget {
  organizationId: string;
  locationId: string | null;
  /** Название цели для текста; null — другая организация без выбранной локации. */
  title: string | null;
}

/**
 * Подтверждение ухода с локации, кассой которой работает этот компьютер:
 * в другой локации или организации принять оплату с этой кассы нельзя.
 */
export function useConfirmLeavingKassa() {
  const authStore = useAuthStore();
  const { confirm } = useConfirm();

  const confirmLeavingKassa = async (target: LocationSwitchTarget): Promise<boolean> => {
    const current = authStore.currentLocation;
    const organizationId = authStore.currentOrganization?.id;

    if (!current || !organizationId || useKassaLocationMarker(organizationId).locationId() !== current.id) {
      return true;
    }
    if (target.organizationId === organizationId && target.locationId === current.id) {
      return true;
    }

    return confirm({
      title: 'Сменить локацию?',
      message: `Этот компьютер работает кассой локации «${current.title}». В «${target.title ?? 'другой организации'}» принять оплату с этой кассы нельзя.`,
      confirmText: 'Перейти',
      cancelText: 'Остаться',
    });
  };

  return { confirmLeavingKassa };
}
